import { Button, Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import { MobileOutlined } from "@ant-design/icons";

const ShowMobile = ({
  title,
  className,
  id,
  type = "default",
  icon = <MobileOutlined />,
  onClick = () => {},
  ...props
}) => {
  const { t } = useTranslation();
  const btnTitle = title || "";

  return (
    <Tooltip trigger={["hover"]} title={t("tooltip.view_in_ess_mobile_app")}>
      <Button
        className={`hover:opacity-70 ${className}`}
        id={id}
        type={type}
        icon={icon}
        onClick={onClick}
        {...props}
      >
        {btnTitle}
      </Button>
    </Tooltip>
  );
};

export default ShowMobile;
